import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Interceptors
import { TokenInterceptor } from './interceptors/token-interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';

// Error Handlers
import { GlobalErrorHandler } from './handlers/global-error.handler';

/**
 * CoreModule
 * 
 * This module should be imported ONCE in AppModule.
 * It contains:
 * - Singleton services
 * - HTTP interceptors
 * - Error handlers
 * - Guards
 * - App-wide configuration
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    // Global Error Handler
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },

    // HTTP Interceptors (order matters!)
    // DOCU-1323: HttpErrorInterceptor liegt aussen. So sieht TokenInterceptor
    // ein 401 zuerst, erneuert den Token und wiederholt — abgemeldet wird erst,
    // wenn auch die Wiederholung scheitert.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  /**
   * Guard against re-importing CoreModule.
   * This ensures CoreModule is only imported once in AppModule.
   */
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only.'
      );
    }
  }
}
